import type { ThemeConfig } from './types';
import { defaultTheme } from './defaultTheme';

export const lightTheme: ThemeConfig = {
  id: 'light',
  name: 'Light',
  canvasBackground: '#f8fafc',
  levelStyles: [
    {
      backgroundColor: '#6366f1',
      textColor: '#ffffff',
      fontSize: 18,
      fontWeight: 'bold',
      borderRadius: 12,
      paddingX: 24,
      paddingY: 14,
    },
    {
      backgroundColor: '#3b82f6',
      textColor: '#ffffff',
      fontSize: 15,
      fontWeight: '600',
      borderRadius: 8,
      paddingX: 16,
      paddingY: 10,
    },
    {
      backgroundColor: '#e2e8f0',
      textColor: '#1e293b',
      fontSize: 14,
      fontWeight: 'normal',
      borderRadius: 6,
      paddingX: 14,
      paddingY: 8,
    },
  ],
  connectorStyle: {
    color: '#94a3b8',
    width: 2,
  },
  selectionColor: '#f59e0b',
  searchHighlightColor: '#22c55e',
};

export const oceanTheme: ThemeConfig = {
  id: 'ocean',
  name: 'Ocean',
  canvasBackground: '#0c1929',
  levelStyles: [
    {
      backgroundColor: '#0891b2',
      textColor: '#ffffff',
      fontSize: 18,
      fontWeight: 'bold',
      borderRadius: 12,
      paddingX: 24,
      paddingY: 14,
    },
    {
      backgroundColor: '#0e7490',
      textColor: '#ecfeff',
      fontSize: 15,
      fontWeight: '600',
      borderRadius: 8,
      paddingX: 16,
      paddingY: 10,
    },
    {
      backgroundColor: '#164e63',
      textColor: '#a5f3fc',
      fontSize: 14,
      fontWeight: 'normal',
      borderRadius: 6,
      paddingX: 14,
      paddingY: 8,
    },
  ],
  connectorStyle: {
    color: '#155e75',
    width: 2,
  },
  selectionColor: '#06b6d4',
  searchHighlightColor: '#2dd4bf',
};

export const forestTheme: ThemeConfig = {
  id: 'forest',
  name: 'Forest',
  canvasBackground: '#0a1f0a',
  levelStyles: [
    {
      backgroundColor: '#16a34a',
      textColor: '#ffffff',
      fontSize: 18,
      fontWeight: 'bold',
      borderRadius: 12,
      paddingX: 24,
      paddingY: 14,
    },
    {
      backgroundColor: '#15803d',
      textColor: '#f0fdf4',
      fontSize: 15,
      fontWeight: '600',
      borderRadius: 8,
      paddingX: 16,
      paddingY: 10,
    },
    {
      backgroundColor: '#1a3a1a',
      textColor: '#bbf7d0',
      fontSize: 14,
      fontWeight: 'normal',
      borderRadius: 6,
      paddingX: 14,
      paddingY: 8,
    },
  ],
  connectorStyle: {
    color: '#166534',
    width: 2,
  },
  selectionColor: '#f59e0b',
  searchHighlightColor: '#a3e635',
};

export const allThemes: ThemeConfig[] = [
  defaultTheme,
  lightTheme,
  oceanTheme,
  forestTheme,
];
